import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import type { useSimpleConfirmDialog } from 'containers/ConfirmDialog/useSimpleConfirmDialog';
import { deleteLabels as deleteLabelsRequest } from './labelCatalogApi';

const getDeleteConfirmDialogMessages = (label: string, count = 1) => ({
  header: count === 1 ? 'Label will be deleted' : 'Labels will be deleted',
  subHeader:
    count === 1
      ? `Do you really want to delete ${label}?`
      : `Do you really want to delete ${count} selected labels?`,
  btnConfirm: 'Delete',
  btnSecondaryConfirm: 'Cancel',
});

type UseLabelDeleteActionsParams = {
  confirmDeleteDialog: ReturnType<typeof useSimpleConfirmDialog>;
  invalidateLabels: () => Promise<void>;
};

export const useLabelDeleteActions = ({
  confirmDeleteDialog,
  invalidateLabels,
}: UseLabelDeleteActionsParams) => {
  const deleteLabels = useStableCallback(async (ids: string[]) => {
    await deleteLabelsRequest(ids);
    await invalidateLabels();
  });

  const requestDeleteLabels = useStableCallback(
    async (ids: string[], label?: string): Promise<boolean> => {
      if (
        await confirmDeleteDialog.show(
          getDeleteConfirmDialogMessages(label ?? '', ids.length),
        )
      ) {
        await deleteLabels(ids);
        return true;
      }

      return false;
    },
  );

  return { deleteLabels, requestDeleteLabels };
};
